import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _88163200 = () => interopDefault(import('../pages/vergelijk/autokosten/index.vue' /* webpackChunkName: "pages/vergelijk/autokosten/index" */))
const _fa1d0836 = () => interopDefault(import('../pages/vergelijk/specificaties/index.vue' /* webpackChunkName: "pages/vergelijk/specificaties/index" */))
const _7c65e93f = () => interopDefault(import('../pages/vergelijk/vergelijker/index.vue' /* webpackChunkName: "pages/vergelijk/vergelijker/index" */))
const _2d0b6132 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7a08cd57 = () => interopDefault(import('../pages/ev-blog/artikel/_index.vue' /* webpackChunkName: "pages/ev-blog/artikel/_index" */))
const _471bf634 = () => interopDefault(import('../pages/vergelijk/ev-prestaties/_filter.vue' /* webpackChunkName: "pages/vergelijk/ev-prestaties/_filter" */))
const _1ef9e1e1 = () => interopDefault(import('../pages/vergelijk/autokosten/_carid/_cars.vue' /* webpackChunkName: "pages/vergelijk/autokosten/_carid/_cars" */))
const _493c9dc9 = () => interopDefault(import('../pages/elektrische-auto/_filter.vue' /* webpackChunkName: "pages/elektrische-auto/_filter" */))
const _a4ab1ad8 = () => interopDefault(import('../pages/ev-blog/_index.vue' /* webpackChunkName: "pages/ev-blog/_index" */))
const _4fbd486e = () => interopDefault(import('../pages/elektrische-auto/_model/_brand/_type.vue' /* webpackChunkName: "pages/elektrische-auto/_model/_brand/_type" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/vergelijk/autokosten",
    component: _88163200,
    name: "vergelijk-autokosten"
  }, {
    path: "/vergelijk/specificaties",
    component: _fa1d0836,
    name: "vergelijk-specificaties"
  }, {
    path: "/vergelijk/vergelijker",
    component: _7c65e93f,
    name: "vergelijk-vergelijker"
  }, {
    path: "/",
    component: _2d0b6132,
    name: "index"
  }, {
    path: "/ev-blog/artikel/:index",
    component: _7a08cd57,
    name: "ev-blog-artikel"
  }, {
    path: "/vergelijk/ev-prestaties/:filter?",
    component: _471bf634,
    name: "vergelijk-ev-prestaties-filter"
  }, {
    path: "/vergelijk/autokosten/:carid/:cars?",
    component: _1ef9e1e1,
    name: "vergelijk-autokosten-carid-cars"
  }, {
    path: "/elektrische-auto/:filter?",
    component: _493c9dc9,
    name: "elektrische-auto-filter"
  }, {
    path: "/ev-blog/:index",
    component: _a4ab1ad8,
    name: "ev-blog"
  }, {
    path: "/elektrische-auto/:model?/:brand?/:type?",
    component: _4fbd486e,
    name: "elektrische-auto-model-brand-type"
  }, {
    path: "/ev-blog",
    component: _a4ab1ad8,
    name: "ev-blog"
  }, {
    path: "/vergelijk/vergelijker",
    component: _7c65e93f,
    name: "vergelijker"
  }, {
    path: "*",
    redirect: "/"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
